import { useState, useEffect } from 'react';

/**
 * Hook personalizado para debounce de valores
 * @param {*} value - El valor a debounce
 * @param {number} delay - El delay en milisegundos (por defecto 500ms)
 * @returns {*} El valor con debounce aplicado
 */
const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;

